import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { computed, toRefs, ref, watch, nextTick } from "vue"

import type { GanttBarObject } from "../types"
import useDayjsHelper from "../composables/useDayjsHelper"
import provideConfig from "../provider/provideConfig"

const DEFAULT_DOT_COLOR = "cadetblue"

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttBarTooltip',
  props: {
    bar: {},
    modelValue: { type: Boolean }
  },
  setup(__props: any) {

const TOOLTIP_FORMATS = {
  hour: "HH:mm",
  day: "DD. MMM HH:mm",
  date: "DD. MMM",
  month: "DD. MMMM YYYY",
  week: "DD. MMMM YYYY (WW)"
} as const

const props = __props

const { bar } = toRefs(props)
const { precision, font, barStart, barEnd, rowHeight } = provideConfig()

const tooltipTop = ref("0px")
const tooltipLeft = ref("0px")
watch(
  () => props.bar,
  async () => {
    await nextTick()

    const barId = bar?.value?.ganttBarConfig.id || ""
    if (!barId) {
      return
    }

    const barElement = document.getElementById(barId)
    const { top, left } = barElement?.getBoundingClientRect() || {
      top: 0,
      left: 0
    }
    const leftValue = Math.max(left, 10)
    tooltipTop.value = `${top - 35}px`
    tooltipLeft.value = `${leftValue}px`
  },
  { deep: true, immediate: true }
)

const dotColor = computed(() => bar?.value?.ganttBarConfig.style?.background || DEFAULT_DOT_COLOR)

const { toDayjs } = useDayjsHelper()

const barStartRaw = computed(() => bar.value?.[barStart.value])
const barEndRaw = computed(() => bar.value?.[barEnd.value])

const tooltipContent = computed(() => {
  if (!bar?.value) {
    return ""
  }
  const format = TOOLTIP_FORMATS[precision.value]
  const barStartFormatted = toDayjs(barStartRaw.value).format(format)
  const barEndFormatted = toDayjs(barEndRaw.value).format(format)
  if (barStartFormatted === barEndFormatted) {
    return `${bar.value.ganttBarConfig.label}: ${barStartFormatted}`
  }
  return `${bar.value.ganttBarConfig.label}: ${barStartFormatted} \u2013 ${barEndFormatted}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "g-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "g-gantt-tooltip",
              style: _normalizeStyle({
          top: tooltipTop.value,
          left: tooltipLeft.value,
          fontFamily: _unref(font)
        })
            }, [
              _renderSlot(_ctx.$slots, "default", {
                bar: _unref(bar),
                barStart: barStartRaw.value,
                barEnd: barEndRaw.value
              }, () => [
                _createTextVNode(_toDisplayString(tooltipContent.value), 1)
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})